// extracted by mini-css-extract-plugin
export default {"Container":"Loader_Container__VWCkx","RouterLoaderAnimation":"Loader_RouterLoaderAnimation__SvWRg","Spinner":"Loader_Spinner__6+GTN","SpinnerEl":"Loader_SpinnerEl__MURMT"};